import { put, select } from 'redux-saga/effects';
import { selectedVehicleData } from '../state_selectors';

/**
 * Generator/Saga to handle the action when user select their vehicle(redbook code) at the end of manual lookup.
 * The saga grabs the selected vehicle data from apiResponses and then dispatches 2 actions to
 * 1). Set vehicle data to form state, including nviCode, glassCode (FE doesn't care, but BE needs it)
 * 2). Set vehicle options data to the top layer of apiResponses for future steps, e.g. factor options, standard features, security alarms
 * @param {Object} action - 'FINALISE_MANUAL_LOOKUP' action, include the redbook code selected by user
 */
const finaliseManualLookup = function* (action) {
    if (action.value) {
        const vehicleData = yield select(selectedVehicleData, action.value);
        yield put({ type: 'SET_VEHICLE_FORM_DATA', payload: vehicleData.toJS(), stateKey: 'vertical.quote' });
        yield put({ type: 'SET_MANUAL_LOOKUP_OPTIONS', payload: vehicleData.toJS() });
    }
};

export default [
    'FINALISE_MANUAL_LOOKUP', finaliseManualLookup
];
